export enum PromocodeProviderEnum {
    MACIF = "MACIF",
    FNAC_DARTY = "FNAC_DARTY",
    UNEO = "UNEO",
}